module.exports = __webpack_public_path__ + "assets/yes-invitation-code.4ddc084f.svg";